module.exports = __webpack_public_path__ + "img/team5.380149a9.jpg";